/* eslint-disable ember/no-controller-access-in-routes */
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class IndexRoute extends Route {
  @service
  router;

  constructor() {
    super(...arguments);
    this.router.on('routeDidChange', this.refreshCounts);
  }

  willDestroy() {
    this.router.off('routeDidChange', this.refreshCounts);
    super.willDestroy(...arguments);
  }

  // Single refresh point for the group hub's count cards. Every way of
  // arriving at (or back at) this route ends in a completed transition
  // whose destination includes it:
  //
  //   - entering a group, and switching between groups (parent param
  //     changes, so activate() would not re-fire)
  //   - returning from write / review / view (parent stays active, so the
  //     parent's setupController would not re-run)
  //   - leaving a student back to the group
  //
  // Previously these were three separate call sites across two routes,
  // which double-fired on entry. The controller sequences responses, because
  // publish and move-back also refresh directly.
  refreshCounts = (transition) => {
    if (!transition.to?.find((route) => route.name === this.routeName)) {
      return;
    }
    let ctrl = this.controllerFor('reporting.group');
    ctrl.loadGroupReports();
    // Historic does NOT refresh on every arrival. A past period cannot have
    // moved just because someone came back from an active card, so the
    // controller reloads it only when this group's data isn't held yet
    // (entering, or switching group) or something marked it stale.
    ctrl.refreshHistoricIfNeeded();
  };
}
